import React from 'react'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import TechnologyHead from '../techComponent/TechnologyHead'
import TechnologyNex from '../techComponent/TechnologyNex';

const breadcrumbData = [
  {
    page: "Home",
    slug: "/",
  },
  {
    page: "Technologies",
    slug: "",
  },
  {
    page: "Data integration & visibility",
    slug: "",
  }
]

const techData = {
  label: "Technologies",
  heading: "Data integration & visibility",
  img: "/assets/images/data-intergration-banner.webp",
  alt: "Infrastructure & Cybersecurity",
  description: `
    <p>Records Management System is one of the major requirements of the companies in recent times. It can be physical or electronic or more frequently a combination of both. Companies have also recognized the significance of records management and accept the fact that they can transform the paradigm of business. Data integration and visibility is an integral part of the data management system. The seamless integration ensures accurate data at the fingertips of the clients. To gain competitive dominance in the business, companies are looking forward to integrating the data of all its operations into one place. They are now more focused on investing in data integration and visibility more than ever before.</p>

    <p>At Dox and Box, we provide flexible and customer-specific data integration while collaborating with the internal business systems and nominated service providers. Our dedicated IT team will be working to set-up the process as short and effortlessly as possible. We ensure adequate efficiency and more streamlined processes. Data integration is a precursor of data analysis.</p>

     <p>With data integration, we provide opportunities for our clients to make a secure and sufficient exchange of information with the client. In this process, we provide the technique of combining the data of different sources and then provide it to users into a unified form. Data integration is in high demand as it helps in increasing efficiency and eliminates errors. The speed increases with data integration and also offers system flexibility. This process ensures the decrease in operational cost, also makes sure that the quality and integrity of the company enhance.
    </p>
    
    <p>With Dox and Box, companies can secure their information and efficiently exchange the data. We offer customized services and ensure that our technology becomes their competitive advantage. The integration solution will offer the flexibility to automate the operations. We have jotted down other remarkable benefits of the data integration which includes:</p>

   

    <h2>Smart Solutions</h2>
    <p>Smart Solutions for document management by Dox and Box enable seamless data integration and enhanced visibility across all systems to ensure unified and consistent information flow. The platform connects multiple data sources, providing real-time access, centralized control, improved transparency for better decision-making. With intelligent data synchronization and clear visibility into records, it ensures accuracy, efficiency, a streamlined document management ecosystem.</p>

    <ul>
      <li>Reduce data entry errors and inefficiencies as human dependence will decrease.</li>

      <li>Decision-making ability will improve and productivity will increase.</li>

      <li>With data integration, data visibility will also improve across the entire chain. It will also help in providing better information to clients.</li>

      <li>Higher Visibility: Gain enhanced visibility and control over documents and data through connected and monitored systems.</li>

      <li>The integration of data will increase business efficiency.</li>

      <li>With the help of real-time data integration, the work process will speed up.</li>

    </ul>

    <p>Data integration and visibility will make the work processes more dynamic. It is the principal factor that contributes to acquiring the data from various sources into the electronic format and further integrating it. This process offers a smooth, transitional experience while document storage. It also helps in distinguishing flaws more precisely and debugging them in a very short period. The adoption of the integration technique will also help in growing the business at a great pace.</p>

  `
};

const techNextData = [
  {
    img: "assets/images/infrastructure-cybers.webp",
    title: "Infrastructure & Cybersecurity",
    slug: "/infrastructure"
  },
  {
    img: "/assets/images/data-cyber.webp",
    title: "Data & Analytics",
    slug: "/data-analytics"
  },
];

export default function DataIntegration() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <TechnologyHead data={techData} />
      <TechnologyNex technex={techNextData} />
    </>
  )
}
